import {
  List as ImmutableList,
} from 'immutable';

import {createImmutableMapFromObject} from '../../common/collection/collectionUtils';

const experimentDeserializers = {
  appExperimentMap(data) {
    return data && createImmutableMapFromObject(
      data,
      (map, key, array) => {
        return map.set(key, ImmutableList(array))
      }
    )
  },
};

export default experimentDeserializers;
